import { render } from "./MapZones.vue?vue&type=template&id=b97760a6&ts=true"
import script from "./MapZones.vue?vue&type=script&lang=ts"
export * from "./MapZones.vue?vue&type=script&lang=ts"

import "./MapZones.vue?vue&type=style&index=0&id=b97760a6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__